import React, { useState } from "react";
import MissingChart from "./MissingChart";
import { Button, Col, Row, Spinner } from "reactstrap";
import LinkingDonut from "./LinkingDonut";
import { withNamespaces } from "react-i18next";
import { AI_ONBOARDING_BASE_URL } from "src/modules/3rd-party-management/constants";
import axios from "axios";
import { toast } from "react-toastify";
import { connect } from "react-redux";

const AiCheckChartResponse = ({ 
    token, 
    t, 
    supplierMissing, 
    productMissing, 
    linking 
}) => {
    const [ downloadErrorsReportStatus, setDownloadErrorsReportStatus ] = useState('idle');

    const handleDownloadErrorsReport = () => {
        setDownloadErrorsReportStatus('downloading');

        axios.get(`${AI_ONBOARDING_BASE_URL}/onboarding/issues/download`,
            {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                onDownloadProgress: (e) => {
                    let percentCompleted = Math.round(e.loaded * 100 /
                        e.total);

                    if (percentCompleted >= 100) {
                        setDownloadErrorsReportStatus('completed')
                    }
                }
            }
        ).then((e) => {
            const url = window.URL.createObjectURL(
                new Blob([e.data], { type: "*" })
            );

            const link = document.createElement("a");

            link.href = url;
            link.setAttribute("download", `Errors.xlsx`);

            document.body.appendChild(link);

            link.click();
            link.remove();
        }).catch(() => {
            toast(t("An error occurred while downloading the file."), {
                type: "error",
            });

            setDownloadErrorsReportStatus('failed');
        })
    }

    const {
        unmatched_products,
        unmatched_suppliers,
    } = linking || {};

    const unmatched_products_pct = unmatched_products?.pct || 0;
    const unmatched_suppliers_pct = unmatched_suppliers?.pct || 0;

    const matchedProducts = 100 - unmatched_products_pct;
    const matchedSuppliers = 100 - unmatched_suppliers_pct;

    return (
        <Row>
            <Col 
                sm="12"
                className="d-flex justify-content-end"
            >
                <Button
                    color="warning"
                    onClick={handleDownloadErrorsReport}
                    disabled={downloadErrorsReportStatus === 'downloading'}
                >
                    {downloadErrorsReportStatus === 'downloading' ? (
                        <>
                            <Spinner 
                                color="white" 
                                size='sm' 
                                className="me-2" 
                            />
                            {t('Downloading')}...
                        </>
                    ) : (
                        <>
                            {t('Download Validation Issues Report')}
                        </>
                    )}
                </Button>
            </Col>
            
            <Col sm="12"> 
                <Row>
                    <Col sm="12" className="mb-4">
                        <MissingChart 
                            id="supplierMissingDataChart"
                            title="Supplier Missing Data"
                            missingData={supplierMissing}
                            helpText='Shows which supplier fields are missing or incomplete.Higher values mean poorer data quality for those fields.'
                        />
                    </Col>
                    <Col sm="12" className="mb-4">
                        <MissingChart
                            id="productMissingDataChart"
                            title="Product Missing Data"
                            missingData={productMissing}
                            helpText='Displays missing or incomplete product details.Higher bars indicate lower data completeness.'
                        />
                    </Col>
                    <Col sm="6" className="mb-4">
                        <LinkingDonut 
                            id="suppliersLinkingChart"
                            label="Suppliers Linking"
                            matched={matchedSuppliers}
                            unmatched={unmatched_suppliers_pct}
                            helpText='Shows how many suppliers are successfully linked to products.Higher unmatched percentages indicate incomplete supplier-product relationships.'
                        />
                    </Col>
                    <Col sm="6" className="mb-4">
                        <LinkingDonut 
                            id="productsLinkingChart"
                            label="Products Linking"
                            matched={matchedProducts}
                            unmatched={unmatched_products_pct}
                            helpText="Shows how many products are correctly linked to suppliers.Higher unmatched percentages indicate data gaps that need attention."
                        />
                    </Col>
                </Row>
            </Col>

            <Col sm="12">
                <p>
                    {t('Addressing these issues will help ensure a more accurate and comprehensive analysis. Please check the data and re-upload or contact our support team if you have any questions!')}
                </p>
            </Col>
        </Row>
    );
};

const mapStatetoProps = (state) => {
    const { token } = state.Login;
    return {
        token         :   token
    };
};

export default withNamespaces()(
    connect(
        mapStatetoProps,
        {}
    )(AiCheckChartResponse)
)